'use es6';

import { appendFormFieldGroup } from 'FormsUI/actions/FormDragDrop';
import { updateSelectedFormItem } from 'FormsUI/actions/FormSelection';
import { showPropertyCreatePanel } from 'FormsUI/actions/DialogsAndPanels';
import { receiveProperties } from 'FormsUI/actions/Properties';
import { isNewPropertyNeeded } from 'FormsUI/selectors/FormDefinition';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { createPropertyFromResponse } from 'FormsUI/utils/PropertyCreation';
import { scrollMainPanel } from 'FormsUI/utils/AnimationUtils';
import { removeNullPropertyFormField, populateNullPropertyFormField } from 'FormsUI/actions/FormDragDrop';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { CREATE_NEW_PROPERTY } from '../constants/TrackingInteractionKeys/Editor/FormTab';
function createAction(name) {
  return `@@properties/${name}`;
}
export const SUCCEED_CREATING_PROPERTY = createAction('SUCCEED_CREATING_PROPERTY');
export const RESET_CREATING_PROPERTY = createAction('RESET_CREATING_PROPERTY');
export const SET_NEW_FIELD_TYPE = createAction('SET_NEW_FIELD_TYPE');
export function succeedCreatingProperty() {
  return {
    type: SUCCEED_CREATING_PROPERTY
  };
}
function resetCreatingPropertyState() {
  return {
    type: RESET_CREATING_PROPERTY
  };
}
function setNewFieldType(fieldType = FieldTypes.TEXT) {
  return {
    type: SET_NEW_FIELD_TYPE,
    newFieldType: fieldType
  };
}
export const handleShowModal = fieldType => dispatch => {
  dispatch(setNewFieldType(fieldType));
  dispatch(showPropertyCreatePanel());
};
export const appendAndScrollToFormField = propertyId => dispatch => {
  dispatch(appendFormFieldGroup(propertyId));
  scrollMainPanel(`[id="form-field-${propertyId}"]`);
};
export const handlePropertyCreation = response => (dispatch, getState) => {
  trackEditorInteraction(CREATE_NEW_PROPERTY, {
    error: false
  });
  const state = getState();
  const {
    propertyId,
    newPropertyGroups,
    newProperties
  } = createPropertyFromResponse(response, state);
  dispatch(succeedCreatingProperty());
  dispatch(receiveProperties(newPropertyGroups, newProperties));
  if (isNewPropertyNeeded(state)) {
    dispatch(populateNullPropertyFormField(response));
    dispatch(updateSelectedFormItem(response.fieldType, propertyId));
  } else {
    dispatch(appendAndScrollToFormField(propertyId));
  }
};
export function reset() {
  return dispatch => {
    dispatch(resetCreatingPropertyState());
    dispatch(removeNullPropertyFormField());
  };
}